export const mlayout = [
  {
    name: 'RegularBgrEntity',
    objects: [
      {
        name: 'background',
        type: 'Image',
        width: 1160,
        height: 740,
        scale: 0.6041241496598639,
        images: ['images/init/regular-back-l.jpeg'],
        orientation: {
          land: {
            x: -102.85,
            y: -109.74,
          },
        },
      },
      {
        name: 'bg-reg-p',
        type: 'Image',
        width: 740,
        height: 1230,
        scale: 0.6223533163265307,
        images: ['images/init/regular-back-p.jpeg'],
        orientation: {
          port: {
            x: -94,
            y: -128,
          },
        },
      },
      {
        name: 'Cloud',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'clouds',
        oriented: true,
        spine: 'animations/spine/background/cloud/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -260,
            scale: 0.5,
          },
          port: {
            x: -196,
            y: 64,
            scale: 0.5,
          },
        },
      },
      {
        name: 'delorianBack',
        type: 'TriggerSpine',
        width: 1920,
        height: 1920,
        animation: 'delorean',
        hide: true,
        oriented: true,
        spine: 'animations/spine/background/delorean/skeleton.json',
        tween: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
            scale: 0.5,
          },
          port: {
            x: -210,
            y: 50,
            scale: 0.5,
          },
        },
      },
      {
        name: 'reel',
        type: 'TriggerSpine',
        width: 1920,
        height: 1920,
        animation: 'reel-decor-general',
        oriented: true,
        spine: 'animations/spine/background/reels/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -215,
            scale: 0.5,
          },
          port: {
            x: -210,
            y: 50,
            scale: 0.5,
          },
        },
      },
      {
        name: 'logo',
        type: 'TriggerSpine',
        width: 1920,
        height: 1920,
        animation: 'logo',
        oriented: true,
        spine: 'animations/spine/background/logo/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -210,
            scale: 0.5,
          },
          port: {
            x: -210,
            y: 50,
            scale: 0.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsBgrEntity',
    objects: [
      {
        name: 'Background',
        type: 'Image',
        width: 1160,
        height: 740,
        scale: 0.6041241496598639,
        images: ['images/init/fs-back-l.jpeg'],
        orientation: {
          land: {
            x: -101.19,
            y: -104.73,
          },
        },
      },
      {
        name: 'bg-fs-p',
        type: 'Image',
        width: 740,
        height: 1225,
        scale: 0.6210512329931973,
        images: ['images/init/fs-back-p.jpeg'],
        orientation: {
          port: {
            x: -98,
            y: -123,
          },
        },
      },
      {
        name: 'table-15',
        type: 'BonusImage',
        width: 87,
        height: 113.5,
        freespins: '12',
        scale: 0.5,
        images: ['images/main/logo/15x2.png'],
        orientation: {
          land: {
            x: 108.02,
            y: 120.78,
          },
          port: {
            x: -23.8,
            y: 116.23,
          },
        },
      },
      {
        name: 'table-10',
        type: 'BonusImage',
        width: 87,
        height: 113.5,
        freespins: '8',
        scale: 0.5,
        images: ['images/main/logo/10x3.png'],
        orientation: {
          port: {
            x: -22.29,
            y: 116.23,
          },
          land: {
            x: 103.47,
            y: 119.26,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'LinesEntity',
    objects: [
      {
        name: 'container',
        type: 'LinesContainer',
        x: 70.38,
        y: 0,
        width: 700,
        height: 405,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 129.62,
        y: 67.97,
        scale: 1,
      },
      port: {
        x: -25,
        y: 265,
        scale: 0.87,
      },
    },
  },
  {
    name: 'ReelsEntity',
    objects: [
      {
        name: 'reel-0',
        type: 'Reel',
        x: -1,
        y: 3.67,
        width: 112.665,
        height: 384.335,
      },
      {
        name: 'reel-1',
        type: 'Reel',
        x: 112,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'reel-2',
        type: 'Reel',
        x: 223,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'reel-3',
        type: 'Reel',
        x: 334.34,
        y: 3.67,
        width: 110.665,
        height: 384.335,
      },
      {
        name: 'reel-4',
        type: 'Reel',
        x: 445.34,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: -1.33,
        y: 3,
        width: 557.665,
        height: 381.335,
      },
      {
        name: 'swipe',
        type: 'SpinSwipeButton',
        x: -63,
        y: -11.7,
        width: 700,
        height: 405,
        alpha: '0',
        runtime: { platform: 'mobile,tablet' },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 199.62,
        y: 75.665,
        scale: 1,
      },
      port: {
        x: 30.04,
        y: 272.5,
        scale: 0.89,
      },
    },
  },
  {
    name: 'SymbolValueEntity',
    objects: [
      {
        name: 'symbol-value',
        type: 'SymbolValuePopup',
        x: -70,
        y: -7.7,
        width: '220',
        height: '260',
        color: '#fdfeff',
        texture: 'SymbolValueBack',
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 199.62,
        y: 75.665,
        scale: 1,
      },
      port: {
        x: 25,
        y: 272.5,
        scale: 0.89,
      },
    },
  },
  {
    name: 'UIFrameEntity',
    objects: [
      {
        name: 'frame',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/footer.png',
        orientation: {
          land: {
            x: -750,
            y: 457,
            v: 1,
          },
        },
      },
      {
        name: 'frameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 200,
        from: 'atlases/footer.png',
        orientation: {
          port: {
            x: -500,
            y: 850,
            v: 1,
          },
        },
      },
      {
        name: 'net',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/net-land.png',
        orientation: {
          land: {
            x: -750,
            y: 500,
            v: 1,
          },
        },
      },
      {
        name: 'netFrameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 96.97,
        from: 'atlases/net-port.png',
        orientation: {
          port: {
            x: -499.47,
            y: 937.5,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'OverReelEntity',
    objects: [
      {
        name: 'reel-0',
        type: 'OverReelAnimation',
        x: -1,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'reel-1',
        type: 'OverReelAnimation',
        x: 112,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'reel-2',
        type: 'OverReelAnimation',
        x: 223,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'reel-3',
        type: 'OverReelAnimation',
        x: 334.34,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'reel-4',
        type: 'OverReelAnimation',
        x: 445.34,
        y: 3.67,
        width: 110,
        height: 384.335,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: -1.34,
        y: 3.66,
        width: 557.665,
        height: 380.67,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 199.62,
        y: 75.665,
        scale: 1,
      },
      port: {
        x: 30.04,
        y: 272.5,
        scale: 0.89,
      },
    },
  },
  {
    name: 'FreespinsOverReelsBgrEntity',
    objects: [
      {
        name: 'back-fs',
        type: 'AnimationSpine',
        x: -475,
        y: -262.5,
        width: 1920,
        height: 1080.61,
        animation: 'fs',
        oriented: true,
        scale: 0.5,
        spine: 'animations/spine/back-fs/skeleton.json',
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: -5,
        y: -7.5,
        scale: 1,
      },
      port: {
        x: -215,
        y: 242.5,
        scale: 1,
      },
    },
  },
  {
    name: 'WinAnimationEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'land',
        type: 'WinParticle',
        width: 0,
        height: 0,
        count: 8,
        isAnimate: true,
        lifetime: 3,
        offsetX: 0,
        offsetY: 0,
        particle: 'coin',
        particleName: 'coin_',
        orientation: {
          land: {
            x: 494.13,
            y: 260,
          },
        },
      },
      {
        name: 'port',
        type: 'WinParticle',
        width: 94,
        height: 68,
        count: 8,
        isAnimate: true,
        lifetime: 6,
        offsetX: 0,
        offsetY: 0,
        particle: 'coin',
        particleName: 'coin_',
        orientation: {
          port: {
            x: 268,
            y: 340,
          },
        },
      },
      {
        name: 'tile',
        type: 'Image',
        width: 619,
        height: 403.195,
        scale: 0.6044912211862818,
        images: ['images/main/logo/img.png'],
        orientation: {
          land: {
            x: 175.82,
            y: 72.9,
          },
          port: {
            x: -43.88,
            y: 141.07,
          },
        },
      },
      {
        name: 'bigwins',
        type: 'BigWinTitle',
        width: 0,
        height: 0,
        scale: 0.4,
        orientation: {
          land: {
            x: 480,
            y: 270,
          },
          port: {
            x: 270,
            y: 350,
          },
        },
      },
      {
        name: 'you-win-big',
        type: 'BigWinCounter',
        width: 744.96,
        height: 63.5,
        fontBitmap: 'bitmap',
        letterSpacing: 35,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 70,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 744.96,
        },
        orientation: {
          land: {
            x: 99.94,
            y: 344.795,
          },
          port: {
            x: -109.39,
            y: 630.365,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'TextLineEntity',
    objects: [
      {
        name: 'line-win-text',
        type: 'LineWinText',
        width: 699.915,
        height: 101.62,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 75,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 699.915,
        },
        orientation: {
          land: {
            x: 130.83,
            y: 193.255,
          },
          port: {
            x: -74.2,
            y: 382.525,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'OverBackgroundEntity',
    objects: [
      {
        name: 'tumbleweed',
        type: 'TriggerSpine',
        width: 1920,
        height: 1920,
        animation: 'tumbleweed',
        hide: true,
        oriented: false,
        spine: 'animations/spine/background/tumbleweed/skeleton.json',
        tween: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
            scale: 0.5,
          },
          port: {
            x: -210,
            y: 0,
            scale: 0.5,
          },
        },
      },
      {
        name: 'Infinity',
        type: 'TriggerSpine',
        width: 1920,
        height: 1920,
        animation: 'train',
        oriented: false,
        spine: 'animations/spine/train/skeleton.json',
        tween: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
            scale: 0.5,
          },
          port: {
            x: -210,
            y: 0,
            scale: 0.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuBackEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'AutoMenuEntity',
    objects: [
      {
        name: 'loss-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 143.17,
            y: 389,
          },
        },
      },
      {
        name: 'autoselected',
        type: 'Image',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          port: {
            x: 213.25,
            y: 201.67,
          },
          land: {
            x: 424.29,
            y: 118.83,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 275.17,
            y: 388.5,
          },
        },
      },
      {
        name: 'prevauto',
        type: 'DecreaseAutoButton',
        width: 21,
        height: 30,
        hitzone: 8,
        scale: 0.8786764705882353,
        images: [
          'images/icons/bet-left-0.png',
          'images/icons/bet-left-1.png',
        ],
        orientation: {
          port: {
            x: 56.75,
            y: 215,
          },
          land: {
            x: 266.96,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.84,
            y: 456.5,
          },
        },
      },
      {
        name: 'nextauto',
        type: 'IncreaseAutoButton',
        width: 20,
        height: 30,
        hitzone: 8,
        scale: 0.857843137254902,
        images: [
          'images/icons/bet-right-0.png',
          'images/icons/bet-right-1.png',
        ],
        orientation: {
          port: {
            x: 468.25,
            y: 216.25,
          },
          land: {
            x: 673.38,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.17,
            y: 454.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 151.34,
            y: 582.5,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 280.5,
            y: 581.5,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 148.84,
            y: 649.67,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 410,
          },
          port: {
            x: 278.5,
            y: 649.67,
          },
        },
      },
      {
        name: 'win',
        type: 'AutoLimitSelectedText',
        width: 495.705,
        height: 35,
        text: 'winlimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 495.705,
        },
        orientation: {
          land: {
            x: 233.125,
            y: 362.165,
          },
          port: {
            x: 20.07,
            y: 532.835,
          },
        },
      },
      {
        name: 'loss',
        type: 'AutoLimitSelectedText',
        width: 480.47,
        height: 35,
        text: 'losslimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 480.47,
        },
        orientation: {
          port: {
            x: 31.865,
            y: 341.5,
          },
          land: {
            x: 235.08,
            y: 239.665,
          },
        },
      },
      {
        name: 'loss-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 142.665,
            y: 389.835,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 276.335,
            y: 390.165,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.335,
            y: 457.165,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.665,
            y: 455.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 149,
            y: 583,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 278,
            y: 583,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 149,
            y: 650,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617.5,
            y: 410,
          },
          port: {
            x: 278.335,
            y: 650.665,
          },
        },
      },
      {
        name: 'autoplay',
        type: 'Text',
        width: 426,
        height: 28,
        text: 'autoHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 426,
        },
        orientation: {
          land: {
            x: 263,
            y: 29,
          },
          port: {
            x: 56,
            y: 93,
          },
        },
      },
      {
        name: 'number',
        type: 'Text',
        width: 433,
        height: 35,
        text: 'numberSpins',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 433,
        },
        orientation: {
          land: {
            x: 263,
            y: 69,
          },
          port: {
            x: 56,
            y: 154,
          },
        },
      },
      {
        name: 'settings',
        type: 'Text',
        width: 429,
        height: 34.5,
        text: 'extendedSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 429,
        },
        orientation: {
          land: {
            x: 267,
            y: 191.5,
          },
          port: {
            x: 56,
            y: 280,
          },
        },
      },
      {
        name: 'auto-carousel',
        type: 'AutoCarousel',
        width: 113,
        height: 47.5,
        text: '2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 424.285,
            y: 118.835,
          },
          port: {
            x: 213.75,
            y: 204.5,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658,
            y: 34,
          },
          port: {
            x: 451.84,
            y: 98.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'BetEntity',
    objects: [
      {
        name: 'bet',
        type: 'Text',
        width: 471.335,
        height: 35.92,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 471.335,
        },
        orientation: {
          land: {
            x: 247.665,
            y: 44.755,
          },
          port: {
            x: 40,
            y: 162.5,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658.5,
            y: 30,
          },
          port: {
            x: 451.59,
            y: 165.09,
          },
        },
      },
      {
        name: 'field',
        type: 'BetField',
        width: 474.265,
        height: 356.905,
        numberOfButtons: 24,
        textPosX: 110,
        textPosY: 50,
        texture: 'button-0',
        orientation: {
          land: {
            x: 245.205,
            y: 105.34,
          },
          port: {
            x: 38.005,
            y: 246.915,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'PaytableEntity',
    objects: [
      {
        name: 'PaytableEntity-header-text',
        type: 'Text',
        x: 0,
        y: 21.53,
        width: 960,
        height: 50,
        text: 'paytableHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'PaytableEntity-jackpot-describe-text',
        type: 'Text',
        x: 235.5,
        y: 246.92,
        width: 202,
        height: 50.165,
        context: { jackpot: true },
        text: 'jackpotPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 202,
        },
      },
      {
        name: 'PrevAutoPage',
        type: 'DecreasePageButton',
        x: 271.82,
        y: 465,
        width: 12,
        height: 17,
        hitzone: 8,
        scale: 0.5,
        images: [
          'images/main/paytable/bet-left-0.png',
          'images/main/paytable/bet-left-1.png',
        ],
      },
      {
        name: 'NextAutoPage',
        type: 'IncreasePageButton',
        x: 680,
        y: 464,
        width: 12,
        height: 17,
        hitzone: 8,
        scale: 0.5,
        images: [
          'images/main/paytable/bet-right-0.png',
          'images/main/paytable/bet-right-1.png',
        ],
      },
      {
        name: 'AutoCaruselPage',
        type: 'PageCarousel',
        x: 455.34,
        y: 465,
        width: 15,
        height: 15,
        hitzone: 8,
        scale: 0.5,
        images: [
          'images/main/paytable/dot-0.png',
          'images/main/paytable/dot-1.png',
        ],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.76,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bonus-games',
        type: 'Image',
        x: 270.96,
        y: 55.33,
        width: 416.06,
        height: 270.5,
        scale: 0.6247130155559717,
        images: ['images/main/paytable/2-bg.png'],
      },
      {
        name: 'PaytableEntity-freespins-describe-text',
        type: 'Text',
        x: 215.3,
        y: 330.4,
        width: 529.47,
        height: 50.165,
        text: 'freespinsPayDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 529.47,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.76,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-scatter-describe-text',
        type: 'Text',
        x: 291.52,
        y: 280,
        width: 383.065,
        height: 140.96,
        text: 'scatterPayDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 383.065,
        },
      },
      {
        name: 'freespins-symb',
        type: 'Image',
        x: 407.5,
        y: 104,
        width: 142.05,
        height: 167.88,
        scale: 0.645687062937063,
        images: ['images/main/items/static/1.png'],
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 267.4,
        y: 66.67,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.76,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 267.4,
        y: 66.67,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-wild-describe-text',
        type: 'Text',
        x: 274.4,
        y: 245,
        width: 414.615,
        height: 137.355,
        text: 'wildPayDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 414.615,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 407.5,
        y: 78,
        width: 151.025,
        height: 178.485,
        scale: 0.686479020979021,
        images: ['images/main/items/static/2.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.76,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: '',
        type: 'Image',
        x: 272,
        y: 90,
        width: 426.59,
        height: 247.98,
        scale: 0.7973639150163776,
        images: ['images/main/paytable/respin.png'],
      },
      {
        name: 'PaytableEntity-respin-describe-text',
        type: 'Text',
        x: 232.5,
        y: 320.4,
        width: 501.885,
        height: 50.165,
        text: 'infinityRespinDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 501.885,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 267.4,
        y: 66.67,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.76,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 65,
        width: 960,
        height: 50,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344,
        y: 183,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344,
        y: 155.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344,
        y: 128,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.34,
        y: 342.84,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.34,
        y: 315.33,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.34,
        y: 287.83,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344,
        y: 339.5,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344,
        y: 312,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344,
        y: 284.89,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.5,
        y: 183.28,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583,
        y: 156.61,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 584,
        y: 128,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '1',
        type: 'Image',
        x: 240,
        y: 120,
        width: 100.665,
        height: 97.07,
        scale: 0.41545716783216785,
        images: ['images/main/items/static/1.png'],
      },
      {
        name: '2',
        type: 'Image',
        x: 477.1,
        y: 120,
        width: 100.665,
        height: 97.07,
        scale: 0.41545716783216785,
        images: ['images/main/items/static/2.png'],
      },
      {
        name: 'A',
        type: 'Image',
        x: 240,
        y: 274.95,
        width: 100.665,
        height: 97.07,
        scale: 0.41545716783216785,
        images: ['images/main/items/static/A.png'],
      },
      {
        name: 'B',
        type: 'Image',
        x: 478.55,
        y: 282.27,
        width: 100.665,
        height: 97.07,
        scale: 0.41545716783216785,
        images: ['images/main/items/static/B.png'],
      },
      {
        name: '1-3',
        type: 'PayoutText',
        x: 372,
        y: 183.67,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1-4',
        type: 'PayoutText',
        x: 372,
        y: 155.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1-5',
        type: 'PayoutText',
        x: 372,
        y: 128,
        width: 80,
        height: 21.5,
        text: '€500.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-3',
        type: 'PayoutText',
        x: 619,
        y: 183,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-4',
        type: 'PayoutText',
        x: 619,
        y: 155.5,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-5',
        type: 'PayoutText',
        x: 619,
        y: 128,
        width: 80,
        height: 21.5,
        text: '€2000.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-3',
        type: 'PayoutText',
        x: 372,
        y: 339.5,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-4',
        type: 'PayoutText',
        x: 372,
        y: 312,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-5',
        type: 'PayoutText',
        x: 372,
        y: 284.89,
        width: 80,
        height: 21.5,
        text: '€2000.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-3',
        type: 'PayoutText',
        x: 619,
        y: 342.84,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-4',
        type: 'PayoutText',
        x: 619,
        y: 315.33,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-5',
        type: 'PayoutText',
        x: 619,
        y: 287.83,
        width: 80,
        height: 21.5,
        text: '€1000.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 228.75,
        y: 66.67,
        width: 494.33,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.76,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: '',
        type: 'Text',
        x: 344.11,
        y: 183.23,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344.58,
        y: 155.57,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344.22,
        y: 127.44,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.32,
        y: 183.31,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.29,
        y: 156.14,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 584.27,
        y: 128.02,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 347.28,
        y: 340.25,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 347.08,
        y: 312.91,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 347.39,
        y: 284.79,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.32,
        y: 342.06,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.46,
        y: 316.23,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 582.77,
        y: 287.77,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'C',
        type: 'Image',
        x: 240,
        y: 120,
        width: 101.63,
        height: 98,
        scale: 0.4194388111888112,
        images: ['images/main/items/static/C.png'],
      },
      {
        name: 'D',
        type: 'Image',
        x: 478.42,
        y: 118.87,
        width: 100.595,
        height: 97,
        scale: 0.4151634615384615,
        images: ['images/main/items/static/D.png'],
      },
      {
        name: 'E',
        type: 'Image',
        x: 241.19,
        y: 276.14,
        width: 100,
        height: 96.43,
        scale: 0.412715034965035,
        images: ['images/main/items/static/E.png'],
      },
      {
        name: 'F',
        type: 'Image',
        x: 477.03,
        y: 274.84,
        width: 102,
        height: 98.355,
        scale: 0.4209624125874126,
        images: ['images/main/items/static/F.png'],
      },
      {
        name: 'C-3',
        type: 'PayoutText',
        x: 370.48,
        y: 183.59,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-4',
        type: 'PayoutText',
        x: 369.48,
        y: 155.43,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-5',
        type: 'PayoutText',
        x: 372.15,
        y: 127.93,
        width: 80,
        height: 21.5,
        text: '€500.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-5',
        type: 'PayoutText',
        x: 615.36,
        y: 128.17,
        width: 80,
        height: 21.5,
        text: '€300.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-3',
        type: 'PayoutText',
        x: 619.03,
        y: 183,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-4',
        type: 'PayoutText',
        x: 619.2,
        y: 156.17,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-3',
        type: 'PayoutText',
        x: 377.65,
        y: 340.53,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-4',
        type: 'PayoutText',
        x: 375.82,
        y: 313.36,
        width: 80,
        height: 21.5,
        text: '€30.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-5',
        type: 'PayoutText',
        x: 375.65,
        y: 285.69,
        width: 80,
        height: 21.5,
        text: '€150.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-3',
        type: 'PayoutText',
        x: 619.03,
        y: 342.75,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-4',
        type: 'PayoutText',
        x: 617.2,
        y: 315.08,
        width: 80,
        height: 21.5,
        text: '€30.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-5',
        type: 'PayoutText',
        x: 617.2,
        y: 287.42,
        width: 80,
        height: 21.5,
        text: '€150.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 65,
        width: 960,
        height: 50,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 228.75,
        y: 66.67,
        width: 485.36,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.5,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: '',
        type: 'Text',
        x: 344.39,
        y: 183.32,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344.52,
        y: 155.16,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 344.49,
        y: 127.7,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 584.05,
        y: 183.22,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 583.52,
        y: 156.22,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 584.16,
        y: 127.76,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 347.13,
        y: 339.91,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 347.1,
        y: 312.58,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 347.23,
        y: 284.46,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'G',
        type: 'Image',
        x: 240,
        y: 120,
        width: 100.595,
        height: 97,
        scale: 0.4151634615384615,
        images: ['images/main/items/static/G.png'],
      },
      {
        name: 'H',
        type: 'Image',
        x: 478.19,
        y: 113.14,
        width: 102.665,
        height: 99,
        scale: 0.4237141608391608,
        images: ['images/main/items/static/H.png'],
      },
      {
        name: 'I',
        type: 'Image',
        x: 241.92,
        y: 273.95,
        width: 101.63,
        height: 98,
        scale: 0.4194388111888112,
        images: ['images/main/items/static/I.png'],
      },
      {
        name: 'G-3',
        type: 'PayoutText',
        x: 375,
        y: 183.85,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'G-4',
        type: 'PayoutText',
        x: 375,
        y: 155.51,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'G-5',
        type: 'PayoutText',
        x: 375,
        y: 128.35,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-3',
        type: 'PayoutText',
        x: 618.09,
        y: 183.07,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-4',
        type: 'PayoutText',
        x: 618.42,
        y: 156.41,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-5',
        type: 'PayoutText',
        x: 614.92,
        y: 128.57,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-3',
        type: 'PayoutText',
        x: 375,
        y: 340.93,
        width: 80,
        height: 21.5,
        text: '€3.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-4',
        type: 'PayoutText',
        x: 375,
        y: 313.43,
        width: 80,
        height: 21.5,
        text: '€15.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-5',
        type: 'PayoutText',
        x: 375,
        y: 285.77,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 65,
        width: 960,
        height: 50,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 225.99,
        y: 66.67,
        width: 476.385,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.5,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-lines-header-text',
        type: 'Text',
        x: 0,
        y: 65,
        width: 960,
        height: 50,
        text: 'linesHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'PaytableEntity-lines-describe-text',
        type: 'Text',
        x: 212.55,
        y: 368,
        width: 534.18,
        height: 86.805,
        text: 'payPaytable',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 534.18,
        },
      },
      {
        name: '1l',
        type: 'Image',
        x: 240,
        y: 144.03,
        width: 79.055,
        height: 46.7,
        scale: 0.28132991038888655,
        images: ['images/main/winlines/winline1.png'],
      },
      {
        name: '2l',
        type: 'Image',
        x: 340,
        y: 144.03,
        width: 79.055,
        height: 46.7,
        scale: 0.28132991038888655,
        images: ['images/main/winlines/winline2.png'],
      },
      {
        name: '3l',
        type: 'Image',
        x: 435,
        y: 144.03,
        width: 79.055,
        height: 46.7,
        scale: 0.28132991038888655,
        images: ['images/main/winlines/winline3.png'],
      },
      {
        name: '4l',
        type: 'Image',
        x: 530,
        y: 144.31,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline4.png'],
      },
      {
        name: '5l',
        type: 'Image',
        x: 625,
        y: 144.31,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline5.png'],
      },
      {
        name: '6l',
        type: 'Image',
        x: 240,
        y: 197.5,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline6.png'],
      },
      {
        name: '7l',
        type: 'Image',
        x: 340,
        y: 197.5,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline7.png'],
      },
      {
        name: '8l',
        type: 'Image',
        x: 435,
        y: 197.5,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline8.png'],
      },
      {
        name: '9l',
        type: 'Image',
        x: 530,
        y: 197.5,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline9.png'],
      },
      {
        name: '10l',
        type: 'Image',
        x: 625,
        y: 197.5,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline10.png'],
      },
      {
        name: '11l',
        type: 'Image',
        x: 240,
        y: 250,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline11.png'],
      },
      {
        name: '12l',
        type: 'Image',
        x: 340,
        y: 250.32,
        width: 78.775,
        height: 46.985,
        scale: 0.28134329555175364,
        images: ['images/main/winlines/winline12.png'],
      },
      {
        name: '13l',
        type: 'Image',
        x: 435,
        y: 250,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline13.png'],
      },
      {
        name: '14l',
        type: 'Image',
        x: 530,
        y: 250,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline14.png'],
      },
      {
        name: '15l',
        type: 'Image',
        x: 625,
        y: 250,
        width: 78.775,
        height: 46.985,
        scale: 0.28134329555175364,
        images: ['images/main/winlines/winline15.png'],
      },
      {
        name: '16l',
        type: 'Image',
        x: 240,
        y: 305,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline16.png'],
      },
      {
        name: '17l',
        type: 'Image',
        x: 340,
        y: 305,
        width: 79.055,
        height: 46.985,
        scale: 0.2813409124810876,
        images: ['images/main/winlines/winline17.png'],
      },
      {
        name: '18l',
        type: 'Image',
        x: 435,
        y: 305,
        width: 78.775,
        height: 46.985,
        scale: 0.28134329555175364,
        images: ['images/main/winlines/winline18.png'],
      },
      {
        name: '19l',
        type: 'Image',
        x: 530,
        y: 305,
        width: 79.055,
        height: 46.7,
        scale: 0.28132991038888655,
        images: ['images/main/winlines/winline19.png'],
      },
      {
        name: '20l',
        type: 'Image',
        x: 625,
        y: 305,
        width: 79.055,
        height: 46.7,
        scale: 0.28132991038888655,
        images: ['images/main/winlines/winline20.png'],
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 230.82,
        y: 66.67,
        width: 481.91,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.5,
        scale: 1,
      },
    },
  },
  {
    name: 'GameRulesEntity',
    objects: [
      {
        name: 'GameRulesEntity-about-describe-text',
        type: 'Text',
        x: 253.42,
        y: 124.25,
        width: 456.5,
        height: 44.165,
        text: 'aboutDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 456.5,
        },
      },
      {
        name: 'GameRulesEntity-return-player-describe-text',
        type: 'RtpText',
        x: 247.76,
        y: 209.86,
        width: 466.5,
        height: 52.665,
        text: 'returnDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 466.5,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-describe-text',
        type: 'Text',
        x: 246.25,
        y: 547.09,
        width: 466.5,
        height: 53.665,
        text: 'howPlayDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 466.5,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 330.75,
        y: 564.92,
        width: 290.165,
        height: 31.335,
        context: { jackpot: true },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 290.165,
        },
      },
      {
        name: 'GameRulesEntity-jackpot-describe-text',
        type: 'Text',
        x: 246.5,
        y: 625.17,
        width: 467.835,
        height: 20.665,
        context: { jackpot: true },
        text: 'jackpotDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 467.835,
        },
      },
      {
        name: 'GameRulesEntity-scatter-text',
        type: 'Text',
        x: 246,
        y: 780.67,
        width: 467.835,
        height: 20.665,
        text: 'scatter',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 467.835,
        },
      },
      {
        name: 'GameRulesEntity-scatter-describe-text',
        type: 'Text',
        x: 239.92,
        y: 796.75,
        width: 482.335,
        height: 55.835,
        text: 'scatterDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 482.335,
        },
      },
      {
        name: 'GameRulesEntity-wild-text',
        type: 'Text',
        x: 246.5,
        y: 879.17,
        width: 467.835,
        height: 20.665,
        text: 'wild',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 467.835,
        },
      },
      {
        name: 'GameRulesEntity-wild-describe-text',
        type: 'Text',
        x: 251.42,
        y: 899.75,
        width: 457.835,
        height: 60.335,
        text: 'wildDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 457.835,
        },
      },
      {
        name: 'GameRulesEntity-spin-describe-text',
        type: 'Text',
        x: 244.25,
        y: 2465.5,
        width: 134.335,
        height: 64.665,
        text: 'spinDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-spin-text',
        type: 'Text',
        x: 251.37,
        y: 2409.88,
        width: 109.665,
        height: 29.835,
        text: 'spin',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109.665,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-text',
        type: 'Text',
        x: 593.42,
        y: 2412.05,
        width: 86.335,
        height: 21.835,
        text: 'betHeaderRules',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 86.335,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-describe-text',
        type: 'Text',
        x: 568.42,
        y: 2465.55,
        width: 134.335,
        height: 53.335,
        text: 'betHeaderDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-menu-text',
        type: 'Text',
        x: 310.42,
        y: 2551.55,
        width: 400,
        height: 29.835,
        text: 'menu',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-home-text',
        type: 'Text',
        x: 310.42,
        y: 2610.05,
        width: 400,
        height: 29.835,
        text: 'home',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-cashier-text',
        type: 'Text',
        x: 310.42,
        y: 2666.81,
        width: 400,
        height: 29.835,
        text: 'cashier',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-game-rules-text',
        type: 'Text',
        x: 310.42,
        y: 2724.81,
        width: 400,
        height: 29.835,
        text: 'gameRules',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-paytable-text',
        type: 'Text',
        x: 310.42,
        y: 2783.51,
        width: 400,
        height: 29.835,
        text: 'paytable',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-additional-describe-text',
        type: 'Text',
        x: -6.6,
        y: 3040.67,
        width: 960,
        height: 22.585,
        text: 'additionalDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'GameRulesEntity-generated-describe-text',
        type: 'Text',
        x: -5.08,
        y: 3144.2,
        width: 960,
        height: 29.585,
        text: 'generatedDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'GameRulesEntity-game-settings-text',
        type: 'Text',
        x: 307.39,
        y: 2838.89,
        width: 400,
        height: 29.835,
        text: 'gameSettings',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-stop-header-text',
        type: 'Text',
        x: 418.34,
        y: 2412.05,
        width: 115,
        height: 21.835,
        text: 'startStopBtn',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 115,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 408.84,
        y: 2465.55,
        width: 134.335,
        height: 53.335,
        text: 'startStopBtnDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-pays-describe-text',
        type: 'Text',
        x: 218,
        y: 305.5,
        width: 524,
        height: 53.665,
        text: 'paysDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays2-describe-text',
        type: 'Text',
        x: 218,
        y: 349.5,
        width: 524,
        height: 53.665,
        text: 'paysDescribeP',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays3-describe-text',
        type: 'Text',
        x: 218,
        y: 430.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays4-describe-text',
        type: 'Text',
        x: 218,
        y: 461.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-describe-text',
        type: 'Text',
        x: 218,
        y: 1523.67,
        width: 524,
        height: 41.665,
        text: 'betGameDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 218,
        y: 1766.84,
        width: 524,
        height: 55,
        text: 'startStopDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop2-describe-text',
        type: 'Text',
        x: 218,
        y: 1822.84,
        width: 524,
        height: 55,
        text: 'startStopDescribeD',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-describe-text',
        type: 'Text',
        x: 218,
        y: 1953.34,
        width: 524,
        height: 55,
        text: 'desktopVersionDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv2-describe-text',
        type: 'Text',
        x: 218,
        y: 2008.34,
        width: 524,
        height: 55,
        text: 'desktopVersionDescribeD',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 218,
        y: 2143.3,
        width: 524,
        height: 55,
        text: 'keyboardDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard3-describe-text',
        type: 'Text',
        x: 218,
        y: 2199.07,
        width: 524,
        height: 38.5,
        text: 'keyboardDescribeE',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'scroll',
        type: 'Graphics',
        x: 0,
        y: 0,
        width: 960,
        height: 3211.155,
        alpha: 0,
      },
      {
        name: 'GameRulesEntity-freespins-describe-text',
        type: 'Text',
        x: 239.92,
        y: 692.63,
        width: 482.335,
        height: 38.835,
        text: 'freespinsDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 482.335,
        },
      },
      {
        name: 'GameRulesEntity-freespin1-describe-text',
        type: 'Text',
        x: 218,
        y: 1051.83,
        width: 524,
        height: 60.665,
        text: 'freespinsGameRulesD',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin2-describe-text',
        type: 'Text',
        x: 218,
        y: 1112.67,
        width: 524,
        height: 60.665,
        text: 'freespinsGameRulesE',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin3-describe-text',
        type: 'Text',
        x: 218,
        y: 1174.67,
        width: 524,
        height: 60.665,
        text: 'freespinsGameRulesS',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin4-describe-text',
        type: 'Text',
        x: 218,
        y: 1252.96,
        width: 524,
        height: 39.665,
        text: 'freespinsGameRulesC',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin5-describe-text',
        type: 'Text',
        x: 218,
        y: 1294.17,
        width: 524,
        height: 79.665,
        text: 'freespinsGameRulesR',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin6-describe-text',
        type: 'Text',
        x: 218,
        y: 1374.17,
        width: 524,
        height: 60.665,
        text: 'freespinsGameRulesI',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 272.91,
        y: 2321.5,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['images/main/rules/spin-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 599,
        y: 2321.8,
        width: 70,
        height: 70,
        scale: 0.5,
        images: ['images/main/rules/bet-button-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 441,
        y: 2321.8,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['images/main/rules/spin-1.png'],
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 218,
        y: 1623.76,
        width: 524,
        height: 55,
        text: 'leftHandModeDescription',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'HISTORY - tap to view your latest game bets and payout',
        type: 'Text',
        x: 310,
        y: 2894.9,
        width: 400,
        height: 29.835,
        text: 'history',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-text',
        type: 'Text',
        x: 264.58,
        y: 3.42,
        width: 434.5,
        height: 98,
        text: 'rulesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 434.5,
        },
      },
      {
        name: 'GameRulesEntity-about-game-text',
        type: 'Text',
        x: 217.93,
        y: 84.37,
        width: 524,
        height: 40,
        text: 'about',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-return-player-text',
        type: 'Text',
        x: 217.93,
        y: 192.09,
        width: 524,
        height: 40,
        text: 'return',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays-text',
        type: 'Text',
        x: 217.93,
        y: 267.33,
        width: 524,
        height: 40,
        text: 'pays',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-text',
        type: 'Text',
        x: 217.93,
        y: 513.59,
        width: 524,
        height: 40,
        text: 'howPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin-title-text',
        type: 'Text',
        x: 217.93,
        y: 1000,
        width: 524,
        height: 40,
        text: 'freespinsGameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-text',
        type: 'Text',
        x: 217.93,
        y: 1450,
        width: 524,
        height: 40,
        text: 'betGame',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-text',
        type: 'Text',
        x: 217.5,
        y: 1575,
        width: 524,
        height: 31.335,
        text: 'leftHandMode',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-free-spins-text',
        type: 'Text',
        x: 217.93,
        y: 1705,
        width: 524,
        height: 40,
        text: 'startStop',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-free-spins-text',
        type: 'Text',
        x: 217.27,
        y: 2074.82,
        width: 524,
        height: 40,
        text: 'keyboard',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-button-functions-text',
        type: 'Text',
        x: 219.74,
        y: 2254.96,
        width: 524,
        height: 31.335,
        text: 'buttonFunctions',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-free-spins-text',
        type: 'Text',
        x: 217.06,
        y: 1883.45,
        width: 524,
        height: 40,
        text: 'desktopVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 217.93,
        y: 615,
        width: 524,
        height: 40,
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespins-text',
        type: 'Text',
        x: 246,
        y: 667.54,
        width: 467.835,
        height: 20.665,
        text: 'freespins',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 467.835,
        },
      },
      {
        name: 'GameRulesEntity-additional-text',
        type: 'Text',
        x: 218.47,
        y: 2981,
        width: 524,
        height: 31.335,
        text: 'additional',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-generated-text',
        type: 'Text',
        x: 218.47,
        y: 3087.5,
        width: 524,
        height: 31.335,
        text: 'generated',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 105.5,
        scale: 1,
      },
    },
  },
  {
    name: 'SettingsEntity',
    objects: [
      {
        name: 'settings',
        type: 'Text',
        width: 400,
        height: 28.335,
        text: 'settings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
        orientation: {
          land: {
            x: 280.325,
            y: 62.665,
          },
          port: {
            x: 64,
            y: 96,
          },
        },
      },
      {
        name: 'space',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'desktop' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401.66,
            y: 363.34,
          },
        },
      },
      {
        name: 'space',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'desktop' },
        text: 'space',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64.665,
            y: 367.915,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 176,
          },
          port: {
            x: 403,
            y: 296,
          },
        },
      },
      {
        name: 'sound',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        text: 'sound',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64,
            y: 298.085,
          },
          land: {
            x: 280,
            y: 176,
          },
        },
      },
      {
        name: 'left',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'mobile,tablet' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401,
            y: 363,
          },
        },
      },
      {
        name: 'left',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'mobile,tablet' },
        text: 'leftHand',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 65,
            y: 371,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'turbo',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'turboModeSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 128,
          },
          port: {
            x: 61,
            y: 229,
          },
        },
      },
      {
        name: 'turbo',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 126,
          },
          port: {
            x: 400,
            y: 232,
          },
        },
      },
      {
        name: 'fps',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'fps',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 272,
          },
          port: {
            x: 65,
            y: 444,
          },
        },
      },
      {
        name: 'cheat',
        type: 'Text',
        width: 329,
        height: 27.5,
        context: { debug: true },
        text: 'cheat',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 320,
          },
          port: {
            x: 65,
            y: 517,
          },
        },
      },
      {
        name: 'cheat',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        context: { debug: true },
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 314.5,
          },
          port: {
            x: 401.5,
            y: 517,
          },
        },
      },
      {
        name: 'fps',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 269,
          },
          port: {
            x: 401.5,
            y: 444,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuEntity',
    objects: [
      {
        name: 'menuhome',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-home.png'],
        orientation: {
          land: {
            x: 55,
            y: 70,
          },
          port: {
            x: 107.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-gamerules',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-info-0.png',
          'images/icons/menu-info-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 180,
          },
          port: {
            x: 237.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-paytable',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-paytable-0.png',
          'images/icons/menu-paytable-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 235,
          },
          port: {
            x: 302.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menucashier',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-cashier-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 125,
          },
          port: {
            x: 172.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-settings',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-settings-0.png',
          'images/icons/menu-settings-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 290,
          },
          port: {
            x: 367.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menuhistory',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 3,
        scale: 0.5,
        images: ['images/icons/menu-history-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 345,
          },
          port: {
            x: 432.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIRegularEntity',
    objects: [
      {
        name: 'spin',
        type: 'SpinButton',
        width: 128.335,
        height: 128.335,
        direction: true,
        scale: 0.49359615384615385,
        images: [
          'images/icons/spin-0.png',
          'images/icons/spin-1.png',
        ],
        orientation: {
          land: {
            x: 842.17,
            y: 203,
          },
          port: {
            x: 208.23,
            y: 716,
            v: 1,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 67.835,
        height: 67.835,
        deselect: true,
        direction: true,
        hitzone: 3,
        scale: 0.48453571428571424,
        images: [
          'images/icons/bet-button-0.png',
          'images/icons/bet-button-1.png',
        ],
        orientation: {
          port: {
            x: 115.5,
            y: 763.5,
            v: 1,
          },
          land: {
            x: 873.34,
            y: 349,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 6,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775.5,
            v: 1,
          },
        },
      },
      {
        name: 'autostop',
        type: 'ImageButton',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.4430379746835443,
        images: ['images/icons/stop-autoplay.png'],
        orientation: {
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
          land: {
            x: 867.83,
            y: 27,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 70,
        height: 70,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/auto-menu-0.png',
          'images/icons/auto-menu-1.png',
        ],
        orientation: {
          land: {
            x: 872.67,
            y: 32,
          },
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'autospin-text',
        type: 'AutoCountText',
        width: 50,
        height: 50,
        direction: true,
        text: '10',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 881.165,
            y: 241,
          },
          port: {
            x: 246.16,
            y: 754,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'WinText',
        width: 206,
        height: 17.5,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 206,
        },
        orientation: {
          port: {
            x: 163.5,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 385,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-count',
        type: 'FreeBetLeft',
        width: 100,
        height: 17.5,
        text: '$5,00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 702.5,
            y: 480.5,
            v: 1,
          },
          port: {
            x: 338.595,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'Text',
        width: 135,
        height: 17.5,
        text: 'win',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 135,
        },
        orientation: {
          port: {
            x: 198,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 418.895,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-text',
        type: 'FreeBetText',
        width: 135,
        height: 17.5,
        text: 'freeBetLeft',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 682.115,
            y: 463,
            v: 1,
          },
          port: {
            x: 317.45,
            y: 869.23,
            v: 1,
          },
        },
      },
      {
        name: 'sound-bg',
        type: 'Image',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.5185185185185185,
        images: ['images/underlay/circle-small.png'],
        orientation: {
          land: {
            x: 872,
            y: 118,
          },
          port: {
            x: 353,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 52.71,
        height: 45.18,
        direction: true,
        scale: 0.753,
        images: [
          'images/icons/sound-0.png',
          'images/icons/sound-1.png',
        ],
        orientation: {
          land: {
            x: 880.56,
            y: 129.82,
          },
          port: {
            x: 361.13,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIFreespinsEntity',
    objects: [
      {
        name: 'frame-spin',
        type: 'Image',
        width: 130,
        height: 130,
        direction: true,
        scale: 0.5,
        images: ['images/icons/spin-0.png'],
        orientation: {
          land: {
            x: 842.17,
            y: 203,
          },
          port: {
            x: 206.67,
            y: 713.5,
            v: 1,
          },
        },
      },
      {
        name: 'freespinsCount',
        type: 'FreespinsCountText',
        width: 124,
        height: 124,
        direction: true,
        text: '15',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 124,
        },
        orientation: {
          land: {
            x: 844.62,
            y: 205.42,
          },
          port: {
            x: 210.335,
            y: 717.165,
            v: 1,
          },
        },
      },
      {
        name: 'total-name-p',
        type: 'Text',
        width: 153.335,
        height: 17.5,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 153.335,
        },
        orientation: {
          port: {
            x: 264,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'total-name',
        type: 'Text',
        width: 150,
        height: 17.5,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 150,
        },
        orientation: {
          land: {
            x: 675.21,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'total-value-p',
        type: 'FreespinsTotalWinText',
        width: 241,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 241,
        },
        orientation: {
          port: {
            x: 223,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'total-value',
        type: 'FreespinsTotalWinText',
        width: 206,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 206,
        },
        orientation: {
          land: {
            x: 645.64,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-text-fs',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'youWinName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 192,
            y: 463.565,
            v: 1,
          },
          port: {
            x: 152,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-fs',
        type: 'WinText',
        width: 217.67,
        height: 17.5,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 217.67,
        },
        orientation: {
          port: {
            x: 97.33,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 134.565,
            y: 479.935,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIGeneralEntity',
    objects: [
      {
        name: 'bet-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 843.5,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'balance-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'balance',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 24,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 19.75,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value',
        type: 'BetText',
        width: 175.76,
        height: 17.5,
        text: '$ 2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175.76,
        },
        orientation: {
          land: {
            x: 767.075,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'balance-value',
        type: 'BalanceText',
        width: 214.325,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 214.325,
        },
        orientation: {
          port: {
            x: 24,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 19.835,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-name-p',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 424,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value-p',
        type: 'BetText',
        width: 175,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175,
        },
        orientation: {
          port: {
            x: 349,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'timer-clock',
        type: 'TimerText',
        width: 50,
        height: 17.5,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 20,
            y: 510,
            v: 1,
          },
          port: {
            x: 24,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'timer-name',
        type: 'Text',
        width: 74.55,
        height: 17.5,
        text: 'timeElapsed',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 74.55,
        },
        orientation: {
          land: {
            x: 75,
            y: 510,
            v: 1,
          },
          port: {
            x: 75.175,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-balance',
        type: 'NetPosition',
        width: 81.945,
        height: 17.5,
        text: '',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 81.945,
        },
        orientation: {
          land: {
            x: 860.5,
            y: 510,
            v: 1,
          },
          port: {
            x: 440,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-name',
        type: 'Text',
        width: 75.175,
        height: 17.5,
        text: 'netPosition',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 75.175,
        },
        orientation: {
          land: {
            x: 784,
            y: 510,
            v: 1,
          },
          port: {
            x: 363,
            y: 939,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsEndEntity',
    objects: [
      {
        name: 'background',
        type: 'Image',
        width: 1160,
        height: 740,
        scale: 0.6041241496598639,
        images: ['images/init/regular-back-l.jpeg'],
        orientation: {
          land: {
            x: -87.57,
            y: -88.18,
          },
        },
      },
      {
        name: 'bg-reg-p',
        type: 'Image',
        width: 740,
        height: 1240,
        scale: 0.6249574829931973,
        images: ['images/init/regular-back-p.jpeg'],
        orientation: {
          port: {
            x: -82.12,
            y: -126.66,
          },
        },
      },
      {
        name: 'freenspinsText',
        type: 'FreespinsTotalWinPopupText',
        width: 610,
        height: 71.5,
        fontBitmap: 'bitmap',
        letterSpacing: 35,
        text: '50.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 65,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 610,
        },
        orientation: {
          land: {
            x: 179.47,
            y: 277.685,
          },
        },
      },
      {
        name: 'freenspinsTextP',
        type: 'FreespinsTotalWinPopupText',
        width: 522.275,
        height: 71.5,
        fontBitmap: 'bitmap',
        letterSpacing: 35,
        text: '50.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 522.275,
        },
        orientation: {
          port: {
            x: 10.075,
            y: 503.945,
          },
        },
      },
      {
        name: 'you-won',
        type: 'Image',
        width: 159.5,
        height: 51,
        scale: 0.5,
        images: ['images/main/logo/you-won.png'],
        orientation: {
          land: {
            x: 405.35,
            y: 188.14,
          },
          port: {
            x: 193.23,
            y: 391.17,
          },
        },
      },
      {
        name: 'endFreespin',
        type: 'ImageButton',
        width: 83.5,
        height: 56.5,
        hitzone: 6,
        scale: 0.5,
        images: ['images/main/logo/endFS.png'],
        orientation: {
          land: {
            x: 441.47,
            y: 379.28,
          },
          port: {
            x: 222.92,
            y: 717.72,
          },
        },
      },
      {
        name: 'endFreespinText',
        type: 'Text',
        width: 136.67,
        height: 52.325,
        hide: true,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 22.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 136.67,
        },
        orientation: {
          land: {
            x: 238.325,
            y: 247.405,
          },
        },
      },
      {
        name: 'endFreespinText-p',
        type: 'Text',
        width: 110.815,
        height: 48.405,
        hide: true,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 22.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 110.815,
        },
        orientation: {
          port: {
            x: 209.595,
            y: 595.795,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsStartEntity',
    objects: [
      {
        name: 'background',
        type: 'Image',
        width: 1160,
        height: 740,
        scale: 0.6041241496598639,
        images: ['images/init/regular-back-l.jpeg'],
        orientation: {
          land: {
            x: -87.57,
            y: -88.18,
          },
        },
      },
      {
        name: 'bg-reg-p',
        type: 'Image',
        width: 740,
        height: 1255,
        scale: 0.6288637329931973,
        images: ['images/init/regular-back-p.jpeg'],
        orientation: {
          port: {
            x: -68.12,
            y: -127.66,
          },
        },
      },
      {
        name: 'startFreespin',
        type: 'ImageButton',
        width: 149,
        height: 60,
        scale: 0.58926213592233,
        images: ['images/main/logo/start.png'],
        orientation: {
          land: {
            x: 400,
            y: 480,
          },
          port: {
            x: 200,
            y: 696,
          },
        },
      },
      {
        name: 'bonus',
        type: 'BonusTwoAnimation',
        width: 0,
        height: 0,
        anim1: 'sherif-wins',
        anim2: 'bandit-wins',
        animation: 'idle',
        oriented: true,
        scale: 0.4,
        spine: 'animations/spine/bonus/skeleton.json',
        orientation: {
          land: {
            x: 475.2,
            y: 325,
          },
          port: {
            x: 270,
            y: 532.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsAddEntity',
    objects: [
      {
        name: 'background',
        type: 'Image',
        width: 1160,
        height: 740,
        scale: 0.6041241496598639,
        images: ['images/init/regular-back-l.jpeg'],
        orientation: {
          land: {
            x: -125.57,
            y: 899.82,
          },
        },
      },
      {
        name: 'bg-reg-p',
        type: 'Image',
        width: 740,
        height: 1160,
        scale: 0.6041241496598639,
        images: ['images/init/regular-back-p.jpeg'],
        orientation: {
          port: {
            x: -66.12,
            y: 1203.34,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreebetEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'bg',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          land: {
            x: 295,
            y: 140.24,
          },
        },
      },
      {
        name: 'bg-p',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          port: {
            x: 95,
            y: 315.36,
          },
        },
      },
      {
        name: 'FB-CLOSE',
        type: 'RadioButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 424.84,
            y: 321.17,
          },
          port: {
            x: 223.29,
            y: 493.22,
          },
        },
      },
      {
        name: 'text',
        type: 'Text',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 424.665,
            y: 323,
          },
          port: {
            x: 223.79,
            y: 494.86,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'FreeBetWinText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetTotalWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 396.715,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'PopupText',
        width: 366.57,
        height: 79.14,
        text: 'freeBetEnd',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 366.57,
        },
        orientation: {
          land: {
            x: 297.38,
            y: 139.765,
          },
          port: {
            x: 95.285,
            y: 317.575,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'FreeBetCountText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetsCount',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 398.5,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'PopupText',
        width: 370.835,
        height: 74.425,
        text: 'congrats',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 294.835,
            y: 139.325,
          },
          port: {
            x: 95.93,
            y: 312.28,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'IntroScreenEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 1,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'introImage',
        type: 'Image',
        width: 1160,
        height: 740,
        scale: 0.6041241496598639,
        images: ['images/init/regular-back-l.jpeg'],
        orientation: {
          land: {
            x: -102.85,
            y: -109.74,
          },
        },
      },
      {
        name: 'IntroBg',
        type: 'Image',
        width: 669.665,
        height: 1147.135,
        scale: 0.5720657259778912,
        images: ['images/init/regular-back-p.jpeg'],
        orientation: {
          port: {
            x: -48,
            y: -127.13,
          },
        },
      },
      {
        name: 'intro-l-sc',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'land',
        oriented: false,
        spine: 'animations/spine/intro-sc/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -2100,
            scale: 0.5,
          },
        },
      },
      {
        name: 'intro-sc-p',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'port',
        oriented: false,
        spine: 'animations/spine/intro-sc/skeleton.json',
        orientation: {
          port: {
            x: -2100,
            y: 0,
            scale: 0.5,
          },
        },
      },
      {
        name: 'intro-l',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'land',
        oriented: false,
        spine: 'animations/spine/intro/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -210,
            scale: 0.5,
          },
        },
      },
      {
        name: 'intro-p',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'port',
        oriented: false,
        spine: 'animations/spine/intro/skeleton.json',
        orientation: {
          port: {
            x: -210,
            y: 0,
            scale: 0.5,
          },
        },
      },
      {
        name: 'close',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-text',
        type: 'Text',
        width: 960,
        height: 58.51,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#e199ff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
        orientation: {
          land: {
            x: 8.425,
            y: 468.98,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-port-text',
        type: 'Text',
        width: 540,
        height: 62.84,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ff99ff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 540,
        },
        orientation: {
          port: {
            x: 2.805,
            y: 813.885,
          },
        },
      },
      {
        name: 'underloader',
        type: 'Image',
        width: 338,
        height: 12,
        scale: 0.5,
        images: ['../base/images/loader/loader-gray.png'],
        orientation: {
          land: {
            x: 313.12,
            y: 488.66,
          },
          port: {
            x: 104.32,
            y: 843.37,
          },
        },
      },
      {
        name: 'loaderline',
        type: 'Loader',
        width: 333,
        height: 8,
        scale: 0.5,
        images: ['../base/images/loader/loader-progress.png'],
        orientation: {
          land: {
            x: 314.36,
            y: 490.71,
          },
          port: {
            x: 106.73,
            y: 845.4,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'SoundPopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'sound-back',
        type: 'Image',
        width: 336,
        height: 173.42,
        scale: 0.5419364919354839,
        images: ['images/underlay/soundBack.png'],
        orientation: {
          land: {
            x: 309,
            y: 179.34,
          },
          port: {
            x: 108.5,
            y: 377,
          },
        },
      },
      {
        name: 'sound-1',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 354,
            y: 249.5,
          },
          port: {
            x: 142,
            y: 448.5,
          },
        },
      },
      {
        name: 'sound-0',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 493,
            y: 249.5,
          },
          port: {
            x: 304,
            y: 448,
          },
        },
      },
      {
        name: 'enable-sound',
        type: 'Text',
        width: 349.335,
        height: 38.165,
        text: 'soundQuestion',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 349.335,
        },
        orientation: {
          land: {
            x: 300,
            y: 199.5,
          },
          port: {
            x: 107.5,
            y: 391.335,
          },
        },
      },
      {
        name: 'sound-yes',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundYes',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 400,
            y: 250,
          },
          port: {
            x: 177.665,
            y: 448,
          },
        },
      },
      {
        name: 'sound-no',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundNo',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 535,
            y: 250,
          },
          port: {
            x: 344.665,
            y: 449,
          },
        },
      },
      {
        name: 'sound-yes-pic',
        type: 'Image',
        width: 24.025,
        height: 26.52,
        scale: 0.4058076923076923,
        images: ['images/icons/sound-1.png'],
        orientation: {
          land: {
            x: 367.09,
            y: 262.08,
          },
          port: {
            x: 152.17,
            y: 460.42,
          },
        },
      },
      {
        name: 'sound-no-pic',
        type: 'Image',
        width: 35,
        height: 30,
        scale: 0.5,
        images: ['images/icons/sound-0.png'],
        orientation: {
          land: {
            x: 505.17,
            y: 261,
          },
          port: {
            x: 316.5,
            y: 459.67,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'PopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'image',
        type: 'PopupButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 418.17,
            y: 324.5,
          },
          port: {
            x: 221.5,
            y: 470,
          },
        },
      },
      {
        name: 'text',
        type: 'PopupButton',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 418,
            y: 326.335,
          },
          port: {
            x: 222.005,
            y: 471.645,
          },
        },
      },
      {
        name: 'body',
        type: 'PopupText',
        width: 475.5,
        height: 168.425,
        text: 'NO INTERNET CONNECTION.\nPLEASE CHECK YOUR CONNECTION\nAND RELOAD THE GAME TO CONTINUE',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 475.5,
        },
        orientation: {
          land: {
            x: 241.5,
            y: 101.325,
          },
          port: {
            x: 37.005,
            y: 280.135,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'FullscreenEntity',
    objects: [
      {
        name: 'fullscreen',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0.5,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'tapa',
        type: 'Image',
        width: 126,
        height: 212.5,
        runtime: {
          os: 'android',
          platform: 'mobile,tablet',
        },
        scale: 0.5,
        images: ['images/icons/fullscreen-1.png'],
        orientation: {
          land: {
            x: 423.67,
            y: 164,
          },
          port: {
            x: 213.5,
            y: 372.84,
          },
        },
      },
      {
        name: 'tap',
        type: 'AnimationSpine',
        width: 329,
        height: 471,
        runtime: {
          os: 'ios',
          platform: 'mobile,tablet',
        },
        spine: 'animations/spine/fullscreen/skeleton.json',
        orientation: {
          land: {
            x: 398,
            y: 147.5,
            scale: 0.5,
          },
          port: {
            x: 197,
            y: 357.5,
            scale: 0.5,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'LoadingEntity',
    objects: [
      {
        name: 'logoanim',
        type: 'LogoSpine',
        width: 960,
        height: 540,
        spine: 'brand/anim/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
          port: {
            x: -410,
            y: 200,
          },
        },
      },
    ],
    properties: { parentGroup: 'INIT' },
  },
  {
    name: 'UIGeneralOverlayEntity',
    objects: [
      {
        name: 'intro-clock-l',
        type: 'ClockText',
        width: 54.765,
        height: 20.4,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.765,
        },
        orientation: {
          land: {
            x: 880.81,
            y: 4.53,
            v: -1,
          },
        },
      },
      {
        name: 'intro-clock-p',
        type: 'ClockText',
        width: 46.835,
        height: 15.835,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 46.835,
        },
        orientation: {
          port: {
            x: 490.775,
            y: 3.42,
            h: 1,
            v: -1,
          },
        },
      },
      {
        name: 'game-name',
        type: 'Text',
        width: 233.115,
        height: 14.795,
        alpha: 0.5,
        force: false,
        text: 'gameName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 6.765,
            y: 0,
            h: -1,
            v: -1,
          },
          port: {
            x: 11.9,
            y: 4.41,
            h: -1,
            v: -1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
]
